import React from 'react';
import AnalystCorner from '../components/forecast/AnalystCorner';

// Page wrapper for Analyst Corner (separate from Forecast tabs)
const AnalystCornerPage: React.FC = () => {
  return (
    <div className="w-full mx-auto">
      <AnalystCorner />
    </div>
  );
};

export default AnalystCornerPage;

